'use client';

import * as DialogPrimitive from '@radix-ui/react-dialog';
import React from 'react';

export const ModalRoot = DialogPrimitive.Root;
export const ModalTrigger = DialogPrimitive.Trigger;

type ModalContentProps = {
	overlayClassname?: string;
};

export const ModalContent = React.forwardRef<
	React.ComponentRef<typeof DialogPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & ModalContentProps
>(({ children, overlayClassname, ...props }, ref) => (
	<DialogPrimitive.Portal>
		<DialogPrimitive.DialogOverlay className={overlayClassname} onClick={(e) => e.stopPropagation()} />
		<DialogPrimitive.Content ref={ref} onClick={(e) => e.stopPropagation()} {...props}>
			{children}
		</DialogPrimitive.Content>
	</DialogPrimitive.Portal>
));
ModalContent.displayName = DialogPrimitive.Content.displayName;

// Wraps children in a <span> to prevent Chrome browser translation from mutating
// React-tracked text nodes (wrapping them in <font> elements), which causes a
// NotFoundError when React tries to removeChild a node that is no longer a direct child.
export const ModalTitle = React.forwardRef<
	React.ComponentRef<typeof DialogPrimitive.Title>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({ children, ...props }, ref) => (
	<DialogPrimitive.Title ref={ref} {...props}>
		<span>{children}</span>
	</DialogPrimitive.Title>
));
ModalTitle.displayName = DialogPrimitive.Title.displayName;

export const ModalDescription = DialogPrimitive.Description;

export const ModalClose = React.forwardRef<
	React.ComponentRef<typeof DialogPrimitive.Close>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Close>
>(({ children, ...props }, ref) => (
	<DialogPrimitive.Close ref={ref} {...props}>
		{children}
	</DialogPrimitive.Close>
));
ModalClose.displayName = DialogPrimitive.Close.displayName;
